import * as React from 'react'
import { memo } from 'react'
const SvgPerson = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 17.29 16"
  >
    <path d="M8.645 6.968a3.355 3.355 0 0 1-2.46-1.023 3.355 3.355 0 0 1-1.023-2.461 3.355 3.355 0 0 1 1.023-2.461A3.355 3.355 0 0 1 8.645 0a3.355 3.355 0 0 1 2.46 1.023 3.355 3.355 0 0 1 1.023 2.461 3.355 3.355 0 0 1-1.023 2.461 3.355 3.355 0 0 1-2.46 1.023ZM0 16v-1.677a2.311 2.311 0 0 1 .435-1.339A2.943 2.943 0 0 1 1.612 12a18.085 18.085 0 0 1 3.532-1.258 15.043 15.043 0 0 1 3.5-.419 15.043 15.043 0 0 1 3.5.419A18.085 18.085 0 0 1 15.677 12a2.943 2.943 0 0 1 1.177.984 2.311 2.311 0 0 1 .435 1.339V16Zm.9-.9h15.484v-.774a1.39 1.39 0 0 0-.306-.855 2.546 2.546 0 0 0-.855-.694 16.277 16.277 0 0 0-3.216-1.145 14.267 14.267 0 0 0-3.365-.4 14.267 14.267 0 0 0-3.365.4 16.277 16.277 0 0 0-3.216 1.145 2.546 2.546 0 0 0-.855.694 1.39 1.39 0 0 0-.306.855Zm7.742-9.032a2.485 2.485 0 0 0 1.823-.758 2.485 2.485 0 0 0 .758-1.823 2.485 2.485 0 0 0-.758-1.823A2.485 2.485 0 0 0 8.642.906a2.485 2.485 0 0 0-1.823.758 2.485 2.485 0 0 0-.758 1.823 2.485 2.485 0 0 0 .758 1.823 2.485 2.485 0 0 0 1.826.755Zm.003-2.584Zm0 11.616Z" />
  </svg>
)
const Memo = memo(SvgPerson)
export default Memo
